<template>
  <card dis-hover :class="['collapsed-card', show ? '' : 'hidden']">
    <div class="card-header">
      <div class="card-header__block">
        <div class="card-header__title" @click="show = !show">
          <icon class="ms-help card-header__title-icon" size="16" :type="icon" />
          <span class="ms-help card-header__title-text">
            {{ title }}
          </span>
          <icon class="ms-help card-header__title-collapse" size="12" type="ios-arrow-down" />
        </div>
        <slot name="dropdown" v-if="show" />
      </div>
    </div>
    <div class="collapsed-card__content" v-show="show">
      <slot />
    </div>
  </card>
</template>

<script>
export default {
  props: ['icon', 'title', 'is-hiding', 'defaultShow'],
  data () {
    return {
      show: this.defaultShow === undefined ? true : this.defaultShow
    }
  },
  created () {
    if (this.isHiding) this.show = false
  }
}
</script>

<style lang="less">
.collapsed-card {
  &.hidden {
    .ivu-card-body {
      padding-bottom: 0;
    }

    .card-header__title-collapse {
      transform: rotateZ(-90deg);
    }
  }

  .card-header__block {
    display: flex;
    align-items: center;
    width: 100%;
  }

  .card-header__title {
    display: flex;
    align-items: center;
    cursor: pointer;
    margin-right: auto;

    &-icon, &-text, &-collapse {
      line-height: 24px;
    }
    &-collapse {
      transition: transform 0.2s ease-in-out;
      margin-left: 8px;
    }
  }

  &-button {
    &.ivu-btn-text:hover, &.ivu-btn-text:focus {
      background: rgba(@primary-color, 0.1);
    }

    &.ms-danger {
      &.ivu-btn-text:hover, &.ivu-btn-text:focus {
        background: rgba(@danger-color, 0.1);
        color: @danger-color;
      }
    }
  }
}
</style>
